var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.197,
    height: 66.856,
    viewBox: "0 0 37.197 66.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185",
    transform: "translate(0.708 66.15) rotate(-90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x2: 65.122,
    transform: "translate(1.029 17.891)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x2: 17.891,
    y2: 17.891,
    transform: "translate(1.029 17.891)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M0,18.863H0L18.919,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinArrow);
export default __webpack_public_path__ + "static/media/thin-arrow.a526598464fbcb2945037c86de27af4e.svg";
export { ForwardRef as ReactComponent };